import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import slugify from 'slugify';
import styles from './styles/AlertBanner.module.scss';

import { OmaLummeApp } from '../../omaLummeContext';

// Actions.
import { fetchAlerts } from '../../actions';
// Types.
import { AlertBannerProps } from '../../types/alerts';
import { HubSpotBlog } from '../../types/news';
import Button from './Button';

const AlertBanner: React.FunctionComponent<AlertBannerProps> = (props: AlertBannerProps) => {
  const dispatch = OmaLummeApp.useDispatch();

  const [alert, setAlert] = useState<HubSpotBlog | null>(null);
  const { t } = useTranslation();
  const { setShowAlertBanner } = props;

  const createLocalStorage = (string: string) => {
    window.localStorage.setItem('AlertBannerDisplayed', string);
  };

  React.useEffect(() => {
    // Create an scoped async function in the hook
    async function fetchAvailableAlerts(): Promise<void> {
      const alertRequest = await fetchAlerts();

      if (alertRequest.status === 503) {
        dispatch(['changeMaintenance', { active: true, message: alertRequest.data.message }]);
      } else {
        dispatch(['changeMaintenance', { active: false, message: '' }]);
      }

      const alerts: HubSpotBlog[] = alertRequest.data;

      setAlert(alerts[0]);
    }
    // Execute the created function directly
    if (!alert) {
      fetchAvailableAlerts();
    }
    if (alert) {
      if (window.localStorage.getItem('AlertBannerDisplayed') && alert.metaDescription !== window.localStorage.getItem('AlertBannerDisplayed')) {
        window.localStorage.removeItem('AlertBannerDisplayed');
      }
      if (window.localStorage.getItem('AlertBannerDisplayed') && alert.metaDescription === window.localStorage.getItem('AlertBannerDisplayed')) {
        setShowAlertBanner(false);
      }
    }
  }, [alert]);

  if (alert) {
    const alertText = alert.metaDescription;
    return (
      <div className={styles.alertBanner}>
        <p>
          {alertText} <a href={`/alert/${slugify(alert.title.toLowerCase())}`}>{t('common:general.readMore')}</a>
        </p>

        <Button
          className="alertBannerClose"
          onClick={(): void => {
            setShowAlertBanner(false);
            createLocalStorage(alertText);
          }}
        >
          {t('common:general.close')}
        </Button>
      </div>
    );
  }
  return null;
};

export default AlertBanner;
